import { Box, Button, Group, Loader, Table as MantineTable } from '@mantine/core';
import React from 'react';

interface TableProps<T>{
    loading? : boolean;
    error? : string;
    data: T[];
    columns: {key:string; title:string; render?: (item:T) => any}[];
    actions?: {onClick:any; title:string; color?:string; loading?: (item:any) => boolean}[];
}
export default function Table(props : TableProps<any>){
    const {actions = [], columns = [], loading = false, error} = props; 
    if(error) return <Group style={{color: "#9a9a9a", padding: '40px 0'}}>Falha ao carregar: {error}</Group>;
    
    return <>
        <div style={{padding: '10px 0'}}>
            {loading && <Loader />}
        </div>
        <MantineTable
            verticalSpacing="xs"
            striped 
            highlightOnHover
        >
            <thead>
                <tr>
                    {columns.map(column=> <th key={column.key}>{column.title}</th>)}
                    {actions.length > 0 && <th style={{width: 200}}>Ações</th>}
                </tr>
            </thead>
            <tbody>
                {props.data.map((item, index) => <tr>
                    {columns.map(column => <td>{column.render ? column.render(item) : item[column.key]}</td>)}
                    {actions.length > 0 && <td>
                        <Box style={{ display: "flex", flexDirection: "row" }}>
                            {actions.map(action => <Button
                                style={{marginRight: 6}}
                                size='xs'
                                color={action.color}
                                loading={action.loading ? action.loading(item) : false}
                                onClick={() => {action.onClick && action.onClick({item, index})}}
                            >{action.title}</Button>)}
                        </Box>
                    </td>}
                </tr>
                )}
            </tbody>
        </MantineTable>
    </>
}